import { Source } from "trader.ts/types/source";
import { dyn } from "trader.ts/ui";

export function renderAsync<T>(
  p: Promise<T>,
  render: (t: T) => HTMLElement | HTMLElement[],
): HTMLElement[] {
  const resolvedS: Source<undefined | T> = new Source(undefined);
  void p.then((t) => resolvedS.set(t));
  return dyn(resolvedS, (resolved) => {
    if (resolved) {
      return render(resolved);
    } else {
      return [];
    }
  });
}
